import { combineReducers } from "redux";

import user from "./userReducer";
import branding from "./brandingReducer";
import notifications from "./notificationsReducer";
import environment from "./environmentReducer";
import notes from "./notesReducer";
import grants from "./grantsReducer";

const rootReducer = combineReducers({
  branding,
  environment,
  user,
  notes,
  grants,
  notifications
});

export default rootReducer;
